import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdArrowDropright } from "react-icons/io";
import {
  FaBolt,
  FaCarBattery,
  FaFan,
  FaShieldAlt,
  FaSolarPanel,
  FaStreetView,
  FaWater,
  FaWrench,
} from "react-icons/fa";

const serviceBlocks = [
  {
    title: "Renewable Energy Solutions",
    desc: "Project delivery techniques for renewable and sustainable energy systems with prompt execution.",
    icon: <FaSolarPanel />,
  },
  {
    title: "Solar Water Pumping System",
    desc: "Installation of solar water pumping systems with dependable after-sale support.",
    icon: <FaWater />,
  },
  {
    title: "Solar Water Heater & Refrigerators",
    desc: "System installation for institutions, hospitals, schools, companies and residential properties.",
    icon: <FaFan />,
  },
  {
    title: "Solar Backup & Photovoltaic System",
    desc: "Installation and servicing of solar backup systems and PV plants for multiple applications.",
    icon: <FaCarBattery />,
  },
  {
    title: "Solar Streetlights & Wind Power",
    desc: "Creative engineering team for streetlight installation and wind power system delivery.",
    icon: <FaStreetView />,
  },
  {
    title: "AC, Generator & Electrical Installations",
    desc: "Residential, commercial and industrial electrical installations and maintenance with proven expertise.",
    icon: <FaBolt />,
  },
  {
    title: "CCTV, Security and Fire Systems",
    desc: "Design, installation and servicing for secure residential and industrial environments.",
    icon: <FaShieldAlt />,
  }
];

export default function HomeBanner3() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <section className="MainBodySection py-5 fr-what-wrap">
      <div className="container">
        <div className="text-center mx-auto mb-4" style={{ maxWidth: 820 }}>
          <h2 className="font-bold text-secondary mb-3">Complete Solar and Energy Service Portfolio</h2>
          <p className="text-muted mb-0">
            DOUBLE F SMART ENERGIES ENTERPRISE delivers field-proven renewable and electrical services for homes, businesses,
            institutions, government operations and industrial projects.
          </p>
        </div>

        <div className="row g-3 g-lg-4">
          {serviceBlocks.map((service) => (
            <div key={service.title} className="col-md-6 col-xl-3">
              <article className="fr-service-card h-100">
                <span className="fr-service-icon">{service.icon}</span>
                <h6 className="font-bold text-secondary mb-2">{service.title}</h6>
                <p className="small text-muted mb-0">{service.desc}</p>
              </article>
            </div>
          ))}
        </div>

        <div className="text-center mt-4 mt-lg-5">
          <button
            className="btn btn-secondary d-inline-flex align-items-center gap-2 fr-btn-pop"
            onClick={() => appContext.navTo({ item: "services" })}
          >
            View Detailed Services <IoMdArrowDropright size={20} />
          </button>
        </div>
      </div>
    </section>
  );
}
